import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Agenda } from './../entities/agenda';
import { catchError } from 'rxjs/operators';
import { AgendaGenerator } from '../entities/agendaGenerator';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  private baseUrl = environment.apiUrl + '/api/agenda/';
  basic: string | string[];

  constructor(private http: HttpClient) { }

  addAgenda(agenda: Agenda): Observable<Agenda> {
    return this.http.post<Agenda>(this.baseUrl, agenda);
  }

  getAdminAgenda(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'openspaces/' + id, httpOptions);
  }

  getUserAgenda(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'openspaces/' + id + '/public', httpOptions);
  }

  updateAgenda(agendaId: number, agenda: Agenda): Observable<any> {
    return this.http.put<Agenda>(`${this.baseUrl} ${ agendaId }`, agenda , httpOptions)
      .pipe(
      catchError(this.handleError<any>('updateAgenda'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getUnassignedProposals(id: number, orderBy: string): Observable<any> {
    return this.http.get(this.baseUrl + 'openspaces/' + id + '/unnasigned?orderBy=' + orderBy);
  }

  generateAgenda(agendaGenerator: AgendaGenerator): Observable<Agenda> {
    return this.http.post<Agenda>(this.baseUrl + 'generate', agendaGenerator);
  }
}
